import { ImageViewer } from 'antd-mobile'
import React, { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import { InlineMath } from 'react-katex'
import styled from 'styled-components'

import { RichTextRenderMobileProps } from './types'
import 'katex/dist/katex.min.css'

/**
 * 富文本渲染组件
 *
 * @param param0 - 参数
 * @param param0.value - 富文本内容
 * @returns 富文本渲染组件
 */
export const RichTextRendererMobile: React.FC<RichTextRenderMobileProps> = ({
  value,
  style,
}) => {
  const editorContentRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const view = editorContentRef.current
    if (!view) return
    view.innerHTML = value
    const formulaEles = view.querySelectorAll('[data-w-e-type="formula"]')
    formulaEles.forEach((f) => {
      const v = f.getAttribute('data-value') || ''
      ReactDOM.render(<InlineMath math={v} />, f)
    })

    const images: NodeListOf<HTMLImageElement> = view.querySelectorAll(
      '.editor-content-view img'
    )
    images.forEach((image) => {
      image.onclick = () => {
        ImageViewer.show({
          image: image.src,
        })
      }
    })
  }, [value])

  return (
    <Renderer
      ref={editorContentRef}
      style={style}
      className="editor-content-view"
    />
  )
}

const Renderer = styled.div`
  max-width: 100%;
  word-break: break-all;
  word-wrap: break-word;
  font-size: 0.4rem;
  h1 {
    font-size: 0.64rem;
  }
  h2 {
    font-size: 0.58rem;
  }
  h3 {
    font-size: 0.53rem;
  }
  h4 {
    font-size: 0.48rem;
  }
  h5 {
    font-size: 0.42rem;
  }
  p,
  span:not[data-w-e-type='formula'] {
    font-size: 0.4rem !important;
    margin-bottom: 0;
    line-height: 0.586rem;
  }
  img {
    max-width: 100%;
    height: auto !important;
  }
  video {
    max-width: 100%;
    width: 100%;
  }
  a {
    font-size: 0.4rem !important;
    text-decoration: none;
  }
  table {
    min-width: 100%;
    border-collapse: collapse;
  }
  th {
    background-color: #f1f1f1;
  }
  th,
  td {
    border: 0.026rem solid #ccc;
    height: 0.5rem;
  }
  span[data-w-e-type='formula'] {
    margin: 0 0.08rem;
    padding: 0 0.08rem;
  }
`
